/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = DocumentExpired
 *
 * 2 = ProcessExpired
 * 
 * 3 = DocumentAwaitingApproval
 * 
 * 4 = UnresolvedFeedback
 */
export enum MyTaskType {
  DocumentExpired = 1,
  ProcessExpired = 2,
  DocumentAwaitingApproval = 3,
  UnresolvedFeedback = 4
}
